import { useState } from 'react';
import { CreateButton, Datagrid, List, NumberField, TextField, useTranslate } from 'react-admin';
import { Box, Card, FormControl } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { usePermissions } from '../../auth/permissions';
import { LIST_ITEM_MAX_COUNT } from '../../config';

// ハードコーディングするデータ
const mockData = [
    { id: 1, planting_date: '2024-10-01', variety: '品種A', target_count: 100, harvest_date: '2024-11-01', cutting_count: 120, yield_count: 95 },
    { id: 2, planting_date: '2024-10-05', variety: '品種B', target_count: 200, harvest_date: '2024-11-10', cutting_count: 210, yield_count: 190 },
    { id: 3, planting_date: '2024-10-10', variety: '品種C', target_count: 150, harvest_date: '2024-11-15', cutting_count: 160, yield_count: 145 },
    { id: 4, planting_date: '2024-10-12', variety: '品種A', target_count: 80, harvest_date: '2024-11-20', cutting_count: 90, yield_count: 85 },
    { id: 5, planting_date: '2024-10-15', variety: '品種B', target_count: 120, harvest_date: '2024-11-25', cutting_count: 130, yield_count: 115 },
];

export const SeedlingList = () => {
	const translate = useTranslate();
	const { isAdmin, isUser } = usePermissions();
	
	const pageTitle = translate('resources.seedling.list');
	const systemName = translate('system.name');
	
	const ListActions = () => (
		
		<Box sx={{ width: '100%', margin: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
			<FormControl sx={{ minWidth: 120, width: 'auto', mt: 1 }} size="small">
			</FormControl>
			<CreateButton />
		</Box>
	);
	
	return (
		<Card>
			<Helmet>
				<title>{`${pageTitle} | ${systemName}`}</title>
			</Helmet>
			<List
				title={pageTitle}
				actions={<ListActions />}
				queryOptions={{
					initialData: { data: mockData, total: mockData.length },
				}}
			>
				<Datagrid
					rowClick={() => false}
					bulkActionButtons={false}
					isRowSelectable={() => false}
					sx={{
						'& .RaDatagrid-headerCell:not(:last-of-type)': {
							borderRight: '1px solid #e0e0e0',
						},
						'& .RaDatagrid-rowCell:not(:last-of-type)': {
							borderRight: '1px solid #e0e0e0',
						},
					}}
				>
					<TextField source="planting_date" />
					<TextField source="variety" />
					<NumberField source="target_count" />
					<TextField source="harvest_date" />
					<NumberField source="cutting_count" />
					<NumberField source="yield_count" />
				</Datagrid>
			</List>
		</Card>
	);
};

export default SeedlingList;